import React, { Component } from "react";
import styled from "react-emotion";
import Slider from "react-slick";
import { Button } from "antd";

import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import ImageAd from "../ads/imageAd/imageAd";
import TextAd from "../ads/textAd";
import { download } from "../../utils/helpers";

const DesktopPreviewContainer = styled("div")({
  position: "relative",
  border: "1px solid #0100002b",
  width: "75%",
  height: "80%",
  fontFamily: "sans-serif, Arial",
  padding: "0 35px 0 25px",
  margin: "auto"
});

const DesktopPreviewItem = styled("div")({
  display: "flex !important",
  justifyContent: "space-between",
  width: "75%"
});

const ButtonWrapper = styled("div")({
  position: "absolute",
  right: 100,
  bottom: 60
});

const Aside = styled("aside")({
  marginLeft: 5
});

const Main = styled("main")({
  marginTop: "20px"
});

const Section = styled("section")({
  display: "flex",
  justifyContent: "space-around",
  margin: "70px 0"
});

const textAdSize = {
  width: 300,
  height: 250
};

const imageAdSize = {
  width: 160,
  height: 600
};

const imageAdSize_2 = {
  width: 728,
  height: 90
};

const imageAdSize_3 = {
  width: 300,
  height: 250
};

class DesktopPreview extends Component {
  state = {};

  handleDownloadAll = async () => {
    this.setState({ loading: true });
    let count = 0;
    let result = [];
    const { previewInfo } = this.props;
    for (let i = 0; i < previewInfo.length; i++) {
      let res = await Promise.all([
        download(
          `parentId${i}`,
          {
            id: "verticalAd",
            marginLeft: "0px",
            marginTop: "0px",
            width: "160px",
            sectionMarginLeft: "0px"
          },
          {
            className: ".vertical-image-ad",
            width: "160px",
            marginTop: "-1px",
            marginLeft: "-1px"
          },
          {
            className: ".vertical-logo-ad",
            width: "60px",
            height: "60px"
          }
        ),
        download(
          `parentId${i}`,
          {
            id: "squareAd_image",
            marginLeft: "0px",
            marginTop: "0px",
            width: "300px",
            sectionMarginLeft: "-1px"
          },
          {
            className: ".square-image-ad",
            width: "300px",
            marginTop: "-3px",
            marginLeft: "-1px"
          },
          {
            className: ".square-logo-ad",
            width: "45px",
            height: "45px"
          }
        ),
        download(
          `parentId${i}`,
          {
            id: "horizontalAd_image",
            marginLeft: "0px",
            marginTop: "0px"
          },
          {
            className: ".horizontal-image-ad",
            width: "172px",
            marginTop: "0px",
            marginLeft: "0px"
          },
          {
            className: ".horizontal-logo-ad",
            width: "50px",
            height: "50px"
          }
        ),
        download(`parentId${i}`, {
          id: "text-ad-container",
          width: "300px",
          marginLeft: "0px",
          marginTop: "0px"
        })
      ]);
      result = [...result, ...res];
    }
    var zip = new JSZip();
    var img = zip.folder("images");
    result.forEach(url => {
      JSZipUtils.getBinaryContent(url, (err, data) => {
        if (err) {
          throw err; // or handle the error
        }
        img.file(`banner${count + 1}.jpg`, data, { binary: true });
        count++;
        if (count === result.length) {
          zip.generateAsync({ type: "blob" }).then(content => {
            saveAs(content, "example.zip");
            this.setState({ loading: false });
          });
        }
      });
    });
  };

  render() {
    const { previewInfo } = this.props;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <DesktopPreviewContainer className="desktopPreviewContainer">
        <Slider {...settings}>
          {previewInfo.map((previewObject, index) => (
            <DesktopPreviewItem id={`parentId${index}`} key={index}>
              <Aside>
                <ImageAd
                  parentId={`parentId${index}`}
                  adSize={imageAdSize}
                  previewObject={previewObject}
                />
              </Aside>
              <Main>
                <ImageAd
                  parentId={`parentId${index}`}
                  adSize={imageAdSize_2}
                  previewObject={previewObject}
                />
                <Section>
                  <ImageAd
                    parentId={`parentId${index}`}
                    adSize={imageAdSize_3}
                    previewObject={previewObject}
                  />
                  <TextAd
                    parentId={`parentId${index}`}
                    adSize={textAdSize}
                    previewObject={previewObject}
                  />
                </Section>
              </Main>
            </DesktopPreviewItem>
          ))}
        </Slider>
        <ButtonWrapper>
          <Button
            type="default"
            title="Download all"
            shape="round"
            icon="download"
            loading={this.state.loading}
            onClick={this.handleDownloadAll}
          >
            Download Banners
          </Button>
        </ButtonWrapper>
      </DesktopPreviewContainer>
    );
  }
}

export default DesktopPreview;
